import React from 'react'
import DocumentLayout from './DocumentLayout'
import WebsiteLayout from './WebsiteLayout'
import LandingLayout from './LandingLayout'

function Layout({ children, layout }) {
  switch (layout) {
    case null:
      return children
    case 'landing':
      return <LandingLayout children={children} darkHeader={false} />
    case 'blog':
    case 'website':
    default:
      return <WebsiteLayout children={children} darkHeader={layout === 'blog'} />
  }
}

function LayoutManager({ children, pageContext }) {
  return (
    <DocumentLayout>
      <Layout layout={pageContext.layout}>{children}</Layout>
    </DocumentLayout>
  )
}

export default LayoutManager
